import { type ReactElement } from 'react'
import { type RelevantGameData } from '@terros/common'
import { Stack, Text } from '@mantine/core'
import { useTranslation, type CompetitionWidgetState } from '@front/model'
import { TButton } from '@components'
import { CompetitionWidgetRow } from './CompetitionWidgetRow'

type Props = {
  state: CompetitionWidgetState
  games: RelevantGameData[]
  now: number
  onOpen: (item: RelevantGameData) => void
  onCreate: () => void
}

/**
 * The competition widget's body. `hidden` is only ever seen where the card is
 * kept on screen anyway, such as the widget preview in the dashboard editor.
 */
export function CompetitionWidgetView({ state, games, now, onOpen, onCreate }: Props): ReactElement {
  const { t } = useTranslation()

  if (state === 'hidden') {
    return (
      <Text c='dimmed' size='sm'>
        {t('No competitions to show. People in this position will not see this widget.')}
      </Text>
    )
  }

  if (state === 'create') {
    return (
      <Stack align='flex-start' gap='xs'>
        <Text c='dimmed' size='sm'>
          {t('No current competitions.')}
        </Text>
        <TButton variant='secondary' onClick={onCreate}>
          {t('Start a Competition')}
        </TButton>
      </Stack>
    )
  }

  return (
    <Stack gap='xs'>
      {games.map((item) => (
        <CompetitionWidgetRow item={item} key={item.game.gameId} now={now} onOpen={onOpen} />
      ))}
    </Stack>
  )
}
